module.exports = __webpack_public_path__ + "static/media/stats.22fcd2ed.svg";